import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.get("/api/data/histories", { params });
};

const getErrorHistories = params => {
  return restApi.post("/api/data/histories/error", params);
}

const dataHistoryService = {
  getAll,
  getErrorHistories
};

export default dataHistoryService;